import "react";
import { jsx as e } from "react/jsx-runtime";
import { QueryClient as t, QueryClientProvider as n } from "@tanstack/react-query";
//#region src/contexts/query-client-provider.tsx
var r = new t({ defaultOptions: { queries: {
	retry: !1,
	refetchInterval: !1,
	refetchOnWindowFocus: !1,
	refetchOnMount: !1,
	refetchIntervalInBackground: !1
} } });
function i({ children: t }) {
	return /* @__PURE__ */ e(n, {
		client: r,
		children: t
	});
}
//#endregion
export { i as QueryClientProvider };
